<template>
  <div>
    <CRow>
      <!-- <CCol sm="12">
        <CButton size="sm" @click="openModal" color="info">
          <i class="fa fa-edit"></i>
           Generate For All Indonesia
        </CButton>
        &nbsp;
      </CCol> -->
      <CCol sm="12">
        <GlobalTable
          :title="'Seller Coverage'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :enableAddButton="true"
          :enableGenerateAllCoverage="true"
          :removeButton="true"
          :redirectDetail="false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @removeData="removeData"
          @generateAllCoverage="generateAllCoverage"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol lg="6">
            <CRow>
              <CCol lg="12">
                <CRow>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="province">Province</label>
                      <model-select
                        class="form-control"
                        id="province"
                        :options="provinceList"
                        v-model="$v.agentCoverageForm.province.$model"
                        :isError="$v.agentCoverageForm.province.$invalid"
                        @input="filterRegency"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.agentCoverageForm.province.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Province should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="regency">Regency</label>
                      <model-select
                        class="form-control"
                        id="regency"
                        :options="regencyList"
                        v-model="$v.agentCoverageForm.regencies.$model"
                        :isError="$v.agentCoverageForm.regencies.$invalid"
                        @input="filterDistrict"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.agentCoverageForm.regencies.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Please select one
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <CRow>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="district">District</label>
                      <model-select
                        class="form-control"
                        id="district"
                        :options="districtList"
                        @input="filterVillage"
                        v-model="$v.agentCoverageForm.district.$model"
                        :isError="$v.agentCoverageForm.district.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.agentCoverageForm.district.$invalid"
                        class="invalid-feedback-custom"
                      >
                        District should be filled.
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="villages">Village</label>
                      <model-select
                        class="form-control"
                        id="villages"
                        :options="villageList"
                        v-model="$v.agentCoverageForm.villages.$model"
                        :isError="$v.agentCoverageForm.villages.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.agentCoverageForm.villages.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Village should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol lg="6">
            <p>Perhatian!!</p>
            <p>
              Jika district dan villages tidak di isi, maka asumsi seluruh district dan village maka akan secara otomatis terisi.<br/>
              Sebagai contoh, jika hanya provinsi Jawa Barat, dan Regency Kab. Bogor yang di isi, maka seluruh district dari Provinsi jawa barat dan Regency Kab. Bogor akan otomatis terisi
            </p>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.agentCoverageForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "AgentCoverage",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "SellerCoverage",
      items: [],
      addButton: false,
      isEdit: false,
      isLoading: false,
      agentCoverageForm: tableInterfaces.agent_coverage,
      activeTab: 0,
      regencyList: [],
      districtList: [],
      villageList: [],
      //   checkedFlag: "Agent",
      fields: [
        { key: "province_name", label: "Provinsi", sorter: true },
        { key: "regencies_name", label: "Kecamatan/Kabupaten", sorter: true },
        { key: "district_name", label: "Distrik/Rayon", sorter: true },
        { key: "villages_name", label: "Kampung", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agent: {
      type: [Array, Object],
      default: () => [],
    },
    provinceList: {
      type: [Array, Object],
      default: () => [],
    },
    agentCoverage: {
      type: [Array, Object],
      default: () => [],
    },
    agentStatus: {
      type: String,
      default: "",
    },
  },
  validations: {
    agentCoverageForm: {
      province: { required },
      regencies: { required },
      district: {},
      villages: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.agentCoverage;
    },
  },
  methods: {
    init: function () {},
    refreshAgentCoverage: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_coverage/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },

    generateAllCoverage: function () {
      //this.addAll();
      if (confirm("Do you want to add All Indonesia ?")) {
        var param ={agent_code:this.agent.agent_code};
        this.isLoading = true;
        this.axios
          .post("console/agent/agent_coverage/all-indonesia", param)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshAgentCoverage(this.agent.id);
          });
      }
      this.resetForm();
    },

    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.agentCoverageForm = item;
      this.callRegencies();
      this.callDistrict();
      this.callVillage();
      this.agentCoverageForm.id = item.id;
      this.addButton = true;
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.isLoading = false;
        this.axios
          .delete("console/agent/agent_coverage/" + item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshAgentCoverage(this.agent.id);
          });
      }
      // bikin api untuk remove
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent_coverage) {
        tableInterfaces.agent_coverage[i] = null;
      }
      this.agentCoverageForm = tableInterfaces.agent_coverage;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.agentCoverageForm.agent_code = this.agent.agent_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/agent/agent_coverage/update", this.agentCoverageForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshAgentCoverage(this.agent.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/agent/agent_coverage/add", this.agentCoverageForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshAgentCoverage(this.agent.id);
            });
        }
      }
    },

    addAll: function () {
      var param ={agent_code:this.agent.agent_code};
        if (confirm("Do you want to add All Indonesia ?")) {
          this.isLoading = true;
          this.axios
            .post("console/agent/agent_coverage/all-indonesia", param)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshAgentCoverage(this.agent.id);
            });
        }
    },

    filterRegency: function () {
      this.agentCoverageForm.regencies = null;
      this.agentCoverageForm.district = null;
      this.agentCoverageForm.villages = null;
      this.regencyList = [];
      this.districtList = [];
      this.villageList = [];
      this.axios
        .get("/console/dropdown/regency/" + this.agentCoverageForm.province)
        .then((response) => {
          this.regencyList = response.data.data;
        });
    },
    filterDistrict: function () {
      this.agentCoverageForm.district = null;
      this.agentCoverageForm.villages = null;
      this.districtList = [];
      this.villageList = [];
      this.axios
        .get("/console/dropdown/district/" + this.agentCoverageForm.regencies)
        .then((response) => {
          this.districtList = response.data.data;
        });
    },
    filterVillage: function () {
      this.agentCoverageForm.villages = null;
      this.villageList = [];
      this.axios
        .get("/console/dropdown/village/" + this.agentCoverageForm.district)
        .then((response) => {
          this.villageList = response.data.data;
        });
    },
    callRegencies: function () {
      this.axios
        .get("/console/dropdown/regency/" + this.agentCoverageForm.province)
        .then((response) => {
          this.regencyList = response.data.data;
        });
    },
    callDistrict: function () {
      this.axios
        .get("/console/dropdown/district/" + this.agentCoverageForm.regencies)
        .then((response) => {
          this.districtList = response.data.data;
        });
    },
    callVillage: function () {
      this.axios
        .get("/console/dropdown/village/" + this.agentCoverageForm.district)
        .then((response) => {
          this.villageList = response.data.data;
        });
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
